<!-- Single unified banner template with dynamic styling and content based on mode -->
@if (bannerConfig().mode !== 'none') {
  <div
    class="hx-impersonation-indicator__container"
    [class]="bannerConfig().containerClass"
    aria-atomic="true"
    aria-live="polite"
    role="alert"
    tabindex="-1"
    [attr.aria-label]="bannerConfig().ariaLabel"
    [style.max-width]="width()">
    <!-- Visual icon wrapper (driven by visualType) -->
    <div
      class="hx-impersonation-indicator__icon-wrapper"
      [class]="'hx-impersonation-indicator__icon-wrapper--' + bannerConfig().mode">
      @switch (bannerConfig().visualType) {
        @case ('pulse-rings') {
          <span class="hx-impersonation-indicator__ring hx-impersonation-indicator__ring--1"></span>
          <span class="hx-impersonation-indicator__ring hx-impersonation-indicator__ring--2"></span>
          <div class="hx-impersonation-indicator__icon-circle">
            <hx-icon
              class="hx-impersonation-indicator__icon"
              [attr.aria-hidden]="true"
              [fontIcon]="bannerConfig().iconName || 'eye'" />
          </div>
        }
        @case ('pulse-dot') {
          <span class="hx-impersonation-indicator__offline-pulse"></span>
          <span class="hx-impersonation-indicator__offline-dot"></span>
        }
        @case ('icon') {
          <div class="hx-impersonation-indicator__status-icon">
            <hx-icon
              [class]="bannerConfig().iconClass || 'hx-impersonation-indicator__icon'"
              [attr.aria-hidden]="true"
              [size]="24"
              [fontIcon]="bannerConfig().iconName || 'info'" />
          </div>
        }
      }
    </div>

    <!-- Content Area -->
    <div class="hx-impersonation-indicator__content">
      <div class="hx-impersonation-indicator__text-group">
        <div class="hx-impersonation-indicator__title">
          @if (bannerConfig().isTitleStrong) {
            <strong>{{ bannerConfig().title }}</strong>
          } @else {
            {{ bannerConfig().title }}
          }
        </div>

        @if (bannerConfig().subtitle) {
          <div class="hx-impersonation-indicator__subtitle">
            {{ bannerConfig().subtitle }}
          </div>
        }
      </div>

      @if (bannerConfig().showProgress) {
        <div class="hx-impersonation-indicator__progress">
          <hx-progress-bar
            variant="linear"
            [mode]="bannerConfig().isIndeterminate ? 'indeterminate' : 'determinate'"
            [value]="bannerConfig().progressValue"
            size="sm"
            context="info" />
        </div>
      }
    </div>

    <!-- Actions Area -->
    <div class="hx-impersonation-indicator__actions flex shrink-0 items-center gap-2">
      @if (bannerConfig().statusBadge; as badge) {
        <div class="hx-impersonation-indicator__status-badge flex shrink-0 items-center gap-2">
          <span
            class="hx-impersonation-indicator__status-dot"
            [style.background-color]="badge.dotColor || 'var(--warning-warning-300, #ffd16b)'"></span>
          <span class="hx-impersonation-indicator__status-badge-text">{{ badge.text }}</span>
        </div>
      }

      @if (bannerConfig().primaryButton; as btn) {
        <button
          hxButton
          variant="fill"
          [context]="btn.context"
          size="sm"
          [attr.aria-label]="btn.ariaLabel"
          class="hx-impersonation-indicator__button"
          [class.hx-impersonation-indicator__button--resync]="btn.action === 'resync'"
          (click)="handlePrimaryAction(btn.action)">
          @if (btn.iconName) {
            <hx-icon [fontIcon]="btn.iconName" [size]="16" class="shrink-0" />
          }
          {{ btn.label }}
        </button>
      }

      @if (bannerConfig().showNavigateToAppointments) {
        <button
          hxIconButton
          variant="ghost"
          context="neutral"
          size="sm"
          fontIcon="arrow_forward"
          aria-label="Go to Appointments"
          [hxTooltip]="'Go to Appointments'"
          position="bottom"
          class="hx-impersonation-indicator__nav-button"
          (click)="navigateToAppointments.emit()"></button>
      }
    </div>
  </div>
}
